import { HeaderKeyControl } from '@/components/HeaderKeyControl';
import {
  useOrganizationLevelApiKeyStatus,
  useGenerateOrganizationLevelApiKey,
} from '@/hooks/api/useApiKeys';
import { useIsSupport } from '@/hooks/useRoleCheck';

interface OrganizationLevelKeyControlProps {
  organizationId: string;
}

/**
 * Organization-Level API Key Control Component
 *
 * Wraps HeaderKeyControl with organization-level API key functionality.
 * Used for MDM installation - all owners can see the key prefix.
 *
 * @param organizationId - The organization ID for API key operations
 */
export function OrganizationLevelKeyControl({
  organizationId,
}: OrganizationLevelKeyControlProps) {
  const statusQuery = useOrganizationLevelApiKeyStatus(organizationId);
  const generateMutation = useGenerateOrganizationLevelApiKey(organizationId);
  const { isSupport } = useIsSupport(organizationId);

  return (
    <HeaderKeyControl
      statusQuery={statusQuery}
      generateMutation={generateMutation}
      disableGenerate={isSupport}
    />
  );
}
